module.exports = __webpack_public_path__ + "img/lg_ring_g_o_0_null.81e29dc7.png";